import React, { useState, useEffect } from 'react';
import axios from 'axios';
import NavigationSecurity from '../../Layouts/Navigation/NavigationSecurity';
import { format } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faPlus, 
    faMagnifyingGlass, 
    faPenToSquare,
    faXmark,
    faPhone,
    faCheckCircle,
    faTimesCircle,
    faBoxOpen,
    faClock,
    faCircleCheck,
    faBuilding,
    faUser,
    faBox,
    faEnvelope,
    faTruck,
    faExclamationTriangle
} from '@fortawesome/free-solid-svg-icons';
import { BASE_URL } from '../../utils/constants';
import useAutoDismissSnack from '../../Hooks/AutoDismissSnack';

import SignatureDialog from './SignatureDialog';

function PackageControl() {

    const getRowColor = (status) => {
        switch (status) {
            case 'Entregado':
                return 'bg-green-50';
            case 'Pendiente':
                return 'bg-orange-50';
            default:
                return '';
        }
    };

    const [paqueteria, setPaqueteria] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [activeFilter, setActiveFilter] = useState('todos'); // 'todos', 'entregados', 'pendientes'
    const [selectedTowerCard, setSelectedTowerCard] = useState('');

    const [selectedPackage, setSelectedPackage] = useState(null);
    const [isEditing, setIsEditing] = useState(false);

    const [openDialog, setOpenDialog] = useState(false);
    const [packageInfo, setPackageInfo] = useState(null);
    const [isPackageRegistered, setIsPackageRegistered] = useState(false);

    const [openAddDialog, setOpenAddDialog] = useState(false);
    const [openEditDialog, setOpenEditDialog] = useState(false);

    const [showSearchForm, setShowSearchForm] = useState(false);
    const [searchFilters, setSearchFilters] = useState({
        torre: '',
        apartamento: '',
        nombre: ''
    });
    const [searchApartments, setSearchApartments] = useState([]);

    const [newPackage, setNewPackage] = useState({
        nombre: '',
        apellido: '',
        telefono: '',
        fecha_recibido: '',
        estado: '',
        observacion: '',
        remitente: '',
        tipo_paquete: '',
        torre: '',
        id_apartamento: '',
        id_usuario: '',
        email: '',
        cantidad: 1
    });

    const [editPackage, setEditPackage] = useState({
        id_paquete: '',
        nombre: '',
        apellido: '',
        telefono: '',
        fecha_recibido: '',
        estado: '',
        observacion: '',
        remitente: '',
        id_tipo_paquete: '',
        torre: '',
        id_apartamento: '',
        id_usuario: '',
        email: '',
        cantidad: ''
    });

    const [torres, setTorres] = useState([]);
    const [torresEdit, setTorresEdit] = useState([]);
    const [apartamentos, setApartamentos] = useState([]);
    const [apartamentosEdit, setApartamentosEdit] = useState([]);
    const [packageTypes, setPackageTypes] = useState([]);
    const [packageTypesEdit, setPackageTypesEdit] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [isApartamentoSelectDisabled, setIsApartamentoSelectDisabled] = useState(true);
    const [aptMora, setAptMora] = useState(false);
    const [moraMensaje, setMoraMensaje] = useState('');

    //Snack notifications
    const [openSnack, setOpenSnack] = React.useState(false);
    const [snackStatus, setSnackStatus] = useState("");
    const [snackMessage, setSnackMessage] = useState("");
    
    const handleClickSnack = () => {
        setOpenSnack(true);
    };

    const handleCloseSnack = () => {
        setOpenSnack(false);
    };
    useAutoDismissSnack(openSnack, setOpenSnack);
    
    const handleClose = () => {
        setOpenDialog(false);
    };

    const getPaqueteria = () => {
        axios.get(`${BASE_URL}/getPaqueteria`)
        .then((response) => {
            setPaqueteria(response.data);
            //console.log(response.data);
        })
        .catch((error) => {
            //console.log(error);
        }
    )}

    const handleAddPackage = (e) => {
        if (e && e.preventDefault) e.preventDefault();
        if (aptMora) {
            setSnackStatus('error');
            setSnackMessage(moraMensaje || 'El apartamento tiene cartera en mora.');
            handleClickSnack();
            return;
        }
        axios.post(`${BASE_URL}/addPackage`, newPackage)
            .then((response) => {
                if (response.status === 200) {
                    setSnackStatus("success");
                    setSnackMessage("Paquete agregado con éxito!");
                    setOpenAddDialog(false);
                    setAptMora(false);
                    setMoraMensaje('');
                    getPaqueteria();
                } else {
                    setSnackStatus("error");
                    setSnackMessage("Error al agregar el paquete.");
                }
                handleClickSnack();
            })
            .catch((error) => {
                setSnackStatus("error");
                if (error.response?.status === 403 && error.response?.data?.message) {
                    setSnackMessage(error.response.data.message);
                    setAptMora(true);
                    setMoraMensaje(error.response.data.message);
                } else {
                    setSnackMessage("Error al agregar el paquete.");
                }
                handleClickSnack();
            });
    };

    const handleInfoPackage = (paquete) => {
        // Obtener los datos frescos del paquete desde el backend
        axios.get(`${BASE_URL}/getPackageById/${paquete.id_paquete}`)
            .then((response) => {
                setPackageInfo(response.data);
                setOpenDialog(true);
            })
            .catch((error) => {
                console.error("Error al obtener información del paquete:", error);
                // Fallback: usar los datos del objeto paquete
                setPackageInfo(paquete);
                setOpenDialog(true);
            });
    };

    //editar paquete

    const handleEditPackage = (paquete) => {
        setOpenEditDialog(true);
        setSelectedPackage(paquete);
        setEditPackage({
            ...paquete,
            torre: paquete.torre, // Asegúrate de que este valor esté correctamente asignado
            id_apartamento: paquete.id_apartamento // Asegúrate de que este valor esté correctamente asignado
        });
        
        // Fetch torres
        fetchTorresEdit();
        handleTipoPaqueteEdit();
    
        // Fetch apartamentos de la torre seleccionada
        /*fetchApartamentosEdit(paquete.torre).then((data) => {
            setApartamentosEdit(data);
            setIsApartamentoSelectDisabled(false);
        });*/
    };

    const fetchTorresEdit = () => {
        axios.get(`${BASE_URL}/towers`)
            .then((response) => {
                if (response.status === 200) {
                    setTorresEdit(response.data);
                    //console.log(response.data);
                } else {
                    setSnackStatus("error");
                    setSnackMessage("Error al obtener las torres.");
                    handleClickSnack();
                }
            })
            .catch((error) => {
                setSnackStatus("error");
                setSnackMessage("Error al obtener las torres.");
                handleClickSnack();
            });
    };

    const handleTorreChangeEdit = (e) => {
        const selectedTorre = e.target.value;
        setEditPackage({ ...editPackage, torre: selectedTorre, id_apartamento: '' });
        fetchApartamentosEdit(selectedTorre).then((data) => {
            setApartamentosEdit(data);
            setIsApartamentoSelectDisabled(false);
        });
    };
    
    const fetchApartamentosEdit = async (id_torre) => {
        try {
            const response = await axios.get(`${BASE_URL}/getApartmentsData/${id_torre}`);
            if (Array.isArray(response.data)) {
                return response.data;
            } else {
                setSnackStatus("error");
                setSnackMessage("Error en el formato de los datos recibidos.");
                handleClickSnack();
                return [];
            }
        } catch (error) {         
            setSnackStatus("error");
            setSnackMessage("Error al obtener los apartamentos.");
            handleClickSnack();
            return [];
        }
    };

    const updatePackage = () => {
        axios.put(`${BASE_URL}/updatePackage`, editPackage)
            .then((response) => {
                if (response.status === 200) {
                    setSnackStatus("success");
                    setSnackMessage("Paquete actualizado con éxito!");
                    handleClickSnack();
                    setOpenEditDialog(false);
                    getPaqueteria();
                } else {
                    setSnackStatus("error");
                    setSnackMessage("Error al actualizar el paquete.");
                    handleClickSnack();
                }
            })
            .catch((error) => {
                setSnackStatus("error");
                setSnackMessage("Error al actualizar el paquete.");
                handleClickSnack();
            });
    };

    
    //registrar paquete

    const [openSignatureDialog, setOpenSignatureDialog] = useState(false);

    const handleRegisterPackage = (paquete) => {
        if (!paquete || !paquete.id_paquete) {
            console.error("Paquete no seleccionado o id_paquete no definido.");
            return;
        }
        setSelectedPackage(paquete);
        setOpenSignatureDialog(true);
    };

    const handleSaveSignature = (filePath) => {
        if (!selectedPackage || !selectedPackage.id_paquete) {
            console.error("Paquete no seleccionado o id_paquete no definido.");
            return;
        }

        const id_paquete = selectedPackage.id_paquete;
        axios.put(`${BASE_URL}/updateStatusPackage`, { id_paquete: id_paquete, signaturePath: filePath })
            .then((response) => {
                if (response.status === 200) {
                    console.log('Paquete registrado con éxito');
                    setSnackStatus("success");
                    setSnackMessage("Paquete registrado con éxito!");
                    handleClickSnack();
                    setOpenSignatureDialog(false);
                    setOpenDialog(false);
                    getPaqueteria();
                } else {
                    console.error('Error al registrar paquete.');
                    setSnackStatus("error");
                    setSnackMessage("Error al registrar paquete.");
                    handleClickSnack();
                }
            })
            .catch((error) => {
                console.error("Error updating package status:", error);
            });
    };


    // Calcular estadísticas
    const stats = {
        total: paqueteria.length,
        entregados: paqueteria.filter(p => p.estado === 'Entregado').length,
        pendientes: paqueteria.filter(p => p.estado === 'Pendiente').length
    };

    const porcentajeEntregados = stats.total > 0 ? Math.round((stats.entregados / stats.total) * 100) : 0;
    const porcentajePendientes = stats.total > 0 ? Math.round((stats.pendientes / stats.total) * 100) : 0;

    const torreChartData = Object.values(
        paqueteria.reduce((acc, paquete) => {
            const towerName = paquete.torre_nombre || 'Sin torre';
            if (!acc[towerName]) {
                acc[towerName] = { torre: towerName, total: 0 };
            }
            acc[towerName].total += 1;
            return acc;
        }, {})
    )
        .sort((a, b) => b.total - a.total)
        .slice(0, 6);

    const towerCardsData = Object.values(
        paqueteria.reduce((acc, paquete) => {
            const key = String(paquete.id_torre || 'sin_torre');
            if (!acc[key]) {
                acc[key] = {
                    id_torre: key,
                    torre_nombre: paquete.torre_nombre || 'Sin torre',
                    total: 0,
                    entregados: 0,
                    pendientes: 0
                };
            }
            acc[key].total += 1;
            if (paquete.estado === 'Entregado') acc[key].entregados += 1;
            if (paquete.estado === 'Pendiente') acc[key].pendientes += 1;
            return acc;
        }, {})
    ).sort((a, b) => a.torre_nombre.localeCompare(b.torre_nombre));

    const maxTowerCount = torreChartData.length > 0 ? torreChartData[0].total : 0;

    // Filtrar los datos de la tabla principal según filtros y estado activo
    const filteredPaqueteria = paqueteria.filter((paquete) => {
        const matchesTower =
            !searchFilters.torre ||
            String(paquete.id_torre) === String(searchFilters.torre);

        const matchesTowerCard =
            !selectedTowerCard ||
            String(paquete.id_torre) === String(selectedTowerCard);

        const matchesApartment =
            !searchFilters.apartamento ||
            String(paquete.id_apartamento) === String(searchFilters.apartamento);

        const fullName = `${paquete.nombre || ''} ${paquete.apellido || ''}`.toLowerCase();
        const matchesName =
            !searchFilters.nombre ||
            fullName.includes(searchFilters.nombre.toLowerCase());
        
        const matchesFilter = 
            activeFilter === 'todos' ? true :
            activeFilter === 'entregados' ? paquete.estado === 'Entregado' :
            activeFilter === 'pendientes' ? paquete.estado === 'Pendiente' :
            true;
        
        return matchesTower && matchesTowerCard && matchesApartment && matchesName && matchesFilter;
    });

    const fetchTorres = () => {
        axios.get(`${BASE_URL}/towers`)
            .then((response) => {
                if (response.status === 200) {
                    setTorres(response.data);
                } else {
                    setSnackStatus("error");
                    setSnackMessage("Error al obtener las torres.");
                    handleClickSnack();
                }
            })
            .catch((error) => {
                setSnackStatus("error");
                setSnackMessage("Error al obtener las torres.");
                handleClickSnack();
            });
    };
    
    const handleTipoPaquete = (e)=>{
        axios.get(`${BASE_URL}/getPackageTypes`)
        .then((response) => {
            if (response.status === 200) {
                setPackageTypes(response.data);
                //console.log(response.data);
            } else {
                setSnackStatus("error");
                setSnackMessage("Error al obtener los tipos de paquete.");
                handleClickSnack();
            }
        })
        .catch((error) => {
            setSnackStatus("error");
            setSnackMessage("Error al obtener los tipos de paquete.");
            handleClickSnack();
        });
    }
    
    const handleTipoPaqueteEdit = (e)=>{
        axios.get(`${BASE_URL}/getPackageTypes`)
        .then((response) => {
            if (response.status === 200) {
                setPackageTypesEdit(response.data);
                //console.log(response.data);
            } else {
                setSnackStatus("error");
                setSnackMessage("Error al obtener los tipos de paquete.");
                handleClickSnack();
            }
        })
        .catch((error) => {
            setSnackStatus("error");
            setSnackMessage("Error al obtener los tipos de paquete.");
            handleClickSnack();
        });
    }

    const handleTorreChange = (e) => {
        const selectedTorre = e.target.value;
        setNewPackage({ ...newPackage, torre: selectedTorre });
        fetchApartamentos(selectedTorre).then((data) => {
            setApartamentos(data);
        });
        setIsApartamentoSelectDisabled(false);
        setAptMora(false);
        setMoraMensaje('');
    };

    const fetchApartamentos = async (id_torre) => {
        try {
            const response = await axios.get(`${BASE_URL}/getApartmentsData/${id_torre}`);
            if (Array.isArray(response.data)) {
                return response.data;
            } else {
                setSnackStatus("error");
                setSnackMessage("Error en el formato de los datos recibidos.");
                handleClickSnack();
                return [];
            }
        } catch (error) {         
            setSnackStatus("error");
            setSnackMessage("Error al obtener los apartamentos.");
            handleClickSnack();
            return [];
        }
    };

    const handleApartamentoChange = (e) => {
        const selectedApartamento = e.target.value;
        setNewPackage({ ...newPackage, id_apartamento: selectedApartamento, id_usuario: '', telefono: '', email: '' });
        setAptMora(false);
        setMoraMensaje('');
        if (selectedApartamento) {
            const apto = apartamentos.find(a => String(a.id_apartamento) === String(selectedApartamento));
            if (apto && apto.estado_cartera === 'en_mora') {
                setAptMora(true);
                setMoraMensaje(`El apartamento ${apto.num_apartamento} tiene pagos pendientes con administración. No se puede recibir paquetería hasta regularizar la cartera.`);
            }
        }
        fetchUserData(selectedApartamento).then((data) => {
            setUsuarios(data);
        });
    };

    const handleUsuarioChange = (event) => {
        const selectedUserId = event.target.value;
        const selectedUsuario = usuarios.find(usuario => String(usuario.id_usuario) === String(selectedUserId));

        if (selectedUsuario) {
            setNewPackage({
                ...newPackage,
                id_usuario: selectedUsuario.id_usuario,
                telefono: selectedUsuario.telefono || '',
                email: selectedUsuario.email || '',
            });
        } else {
            // Clear contact fields if no user matched (robustness)
            setNewPackage({
                ...newPackage,
                id_usuario: selectedUserId,
                telefono: '',
                email: '',
            });
        }
    };

    const fetchUserData = async (id_apartamento) => {
        try {
            const response = await axios.get(`${BASE_URL}/getInquilinoDataByApto/${id_apartamento}`);
            if (Array.isArray(response.data)) {
                //console.log(response.data);
                return response.data;
            } else {
                setSnackStatus("error");
                setSnackMessage("Error en el formato de los datos recibidos.");
                handleClickSnack();
                return [];
            }
        } catch (error) {
            setSnackStatus("error");
            setSnackMessage("Error al obtener los datos del usuario.");
            handleClickSnack();
            return [];
        }
    };

    const handleToggleSearchForm = () => {
        if (showSearchForm) {
            // Si el formulario está abierto, limpiar filtros
            setSearchFilters({
                torre: '',
                apartamento: '',
                nombre: ''
            });
            setSearchApartments([]);
            setPage(0);
        }
        setShowSearchForm(!showSearchForm); // Alternar visibilidad del formulario
    };

    const handleSearchTowerChange = (e) => {
        const selectedTower = e.target.value;
        setSelectedTowerCard(selectedTower);
        setSearchFilters((prev) => ({
            ...prev,
            torre: selectedTower,
            apartamento: ''
        }));
        setPage(0);

        if (selectedTower) {
            fetchApartamentos(selectedTower).then((data) => {
                setSearchApartments(data);
            });
        } else {
            setSearchApartments([]);
        }
    };

    const clearSearchFilters = () => {
        setSearchFilters({ torre: '', apartamento: '', nombre: '' });
        setSelectedTowerCard('');
        setSearchApartments([]);
        setPage(0);
    };

    useEffect(() => {
            fetchTorres();
            handleTipoPaquete();
            getPaqueteria();        
    }, [ ]);

    const formatDate = (dateString) => {
        return format(new Date(dateString), 'yyyy-MM-dd hh:mm:ss a');
    };

    
  return (
    <>
        <NavigationSecurity />

        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 p-4 sm:p-6 lg:p-8">
            <div className="max-w-7xl mx-auto">
                {/* Snackbar Notification */}
                {openSnack && (
                    <div className="fixed top-4 right-4 z-[9999] animate-fade-in">
                        <div className={`flex items-center gap-3 px-6 py-4 rounded-lg shadow-lg ${
                            snackStatus === 'success' ? 'bg-green-50 border border-green-200' : 'bg-red-50 border border-red-200'
                        }`}>
                            {snackStatus === 'success' ? (
                                <FontAwesomeIcon icon={faCheckCircle} className="w-6 h-6 text-green-600" />
                            ) : (
                                <FontAwesomeIcon icon={faTimesCircle} className="w-6 h-6 text-red-600" />
                            )}
                            <p className={`text-sm font-medium ${snackStatus === 'success' ? 'text-green-800' : 'text-red-800'}`}>
                                {snackMessage}
                            </p>
                            <button onClick={handleCloseSnack} className="ml-4">
                                <FontAwesomeIcon icon={faXmark} className={`w-5 h-5 ${snackStatus === 'success' ? 'text-green-600 hover:text-green-800' : 'text-red-600 hover:text-red-800'}`} />
                            </button>
                        </div>
                    </div>
                )}

                {/* Header */}
                <div className="bg-white rounded-2xl shadow-lg px-6 py-6 mb-8">
                    <div className="flex items-center justify-center mb-4">
                        <div className="p-3 bg-gradient-to-br from-teal-500 to-cyan-600 rounded-full shadow-lg">
                            <FontAwesomeIcon icon={faBoxOpen} className="h-12 w-12 text-white" />
                        </div>
                    </div>
                    <h1 className="text-3xl font-bold text-gray-800 text-center mb-2">
                        Control de Paquetería
                    </h1>
                    <p className="text-sm text-gray-600 text-center">
                        Gestión y seguimiento de entregas
                    </p>
                </div>

                {/* Two-column: sidebar + content panel */}
                <div className="flex flex-col xl:flex-row gap-6">

                    {/* Left sidebar: Add button + Tower selector */}
                    <div className="xl:w-72 flex-shrink-0 space-y-4">
                        <button
                            onClick={() => setOpenAddDialog(true)}
                            className="w-full inline-flex items-center justify-center gap-2 px-5 py-3 bg-gradient-to-r from-green-500 to-green-600 text-white font-semibold rounded-xl hover:from-green-600 hover:to-green-700 transition-all duration-300 shadow-md hover:shadow-lg"
                        >
                            <FontAwesomeIcon icon={faPlus} className="w-5 h-5" />
                            Agregar Paquete
                        </button>

                        <div className="bg-white rounded-xl shadow-lg p-4">
                            <div className="flex items-center justify-between mb-3">
                                <h3 className="text-xs font-bold text-gray-600 uppercase tracking-widest">Filtrar por torre</h3>
                                {selectedTowerCard && (
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setSelectedTowerCard('');
                                            setSearchFilters((prev) => ({ ...prev, torre: '', apartamento: '' }));
                                            setSearchApartments([]);
                                            setPage(0);
                                        }}
                                        className="text-xs font-medium text-cyan-700 bg-cyan-50 hover:bg-cyan-100 px-3 py-1.5 rounded-md border border-cyan-100 shadow-sm hover:shadow-md transition-colors duration-150 flex items-center gap-2"
                                    >
                                        <span className="inline-block px-1 py-0.5 bg-white rounded text-cyan-700 text-[11px] font-semibold">Ver todas</span>
                                    </button>
                                )}
                            </div>
                            <div className="space-y-2 max-h-[420px] overflow-y-auto pr-1">
                                {towerCardsData.map((tower) => (
                                    <button
                                        key={tower.id_torre}
                                        type="button"
                                        onClick={() => {
                                            const nextValue = selectedTowerCard === tower.id_torre ? '' : tower.id_torre;
                                            setSelectedTowerCard(nextValue);
                                            setSearchFilters((prev) => ({ ...prev, torre: nextValue, apartamento: '' }));
                                            if (nextValue) {
                                                fetchApartamentos(nextValue).then((data) => setSearchApartments(data));
                                            } else {
                                                setSearchApartments([]);
                                            }
                                            setPage(0);
                                        }}
                                        className={`w-full text-left rounded-xl border px-3 py-3 transition-all ${
                                            selectedTowerCard === tower.id_torre
                                                ? 'border-cyan-500 bg-cyan-50 shadow-sm'
                                                : 'border-gray-200 bg-white hover:border-cyan-300 hover:bg-gray-50'
                                        }`}
                                    >
                                        <div className="flex items-center justify-between">
                                            <p className="font-semibold text-gray-800 text-sm truncate">{tower.torre_nombre}</p>
                                            <span className={`text-lg font-bold ${
                                                selectedTowerCard === tower.id_torre ? 'text-cyan-700' : 'text-gray-600'
                                            }`}>{tower.total}</span>
                                        </div>
                                        <div className="flex gap-3 text-xs mt-1.5">
                                            <span className="flex items-center gap-1 text-green-600">
                                                <span className="w-1.5 h-1.5 rounded-full bg-green-500 inline-block" />
                                                {tower.entregados} ent.
                                            </span>
                                            <span className="flex items-center gap-1 text-amber-600">
                                                <span className="w-1.5 h-1.5 rounded-full bg-amber-400 inline-block" />
                                                {tower.pendientes} pend.
                                            </span>
                                        </div>
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Right panel: search + filter tabs + table */}
                    <div className="flex-1 min-w-0 space-y-4">
                        <div className="flex justify-end">
                            <button
                                onClick={handleToggleSearchForm}
                                className={`inline-flex items-center gap-2 px-5 py-2.5 font-semibold rounded-xl transition-all duration-300 shadow-sm hover:shadow-md ${
                                    showSearchForm
                                        ? 'bg-gray-500 text-white hover:bg-gray-600'
                                        : 'bg-gradient-to-r from-teal-500 to-cyan-600 text-white hover:from-teal-600 hover:to-cyan-700'
                                }`}
                            >
                                {showSearchForm ? <FontAwesomeIcon icon={faXmark} className="w-4 h-4" /> : <FontAwesomeIcon icon={faMagnifyingGlass} className="w-4 h-4" />}
                                {showSearchForm ? 'Cerrar búsqueda' : 'Buscar'}
                            </button>
                        </div>

                        {showSearchForm && (
                            <div className="bg-white rounded-xl shadow-md p-5">
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-3">
                                    <div>
                                        <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">Torre</label>
                                        <select
                                            value={searchFilters.torre}
                                            onChange={handleSearchTowerChange}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                                        >
                                            <option value="">Todas las torres</option>
                                            {torres.map((torre) => (
                                                <option key={torre.id_torre} value={torre.id_torre}>{torre.nombre}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div>
                                        <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">Apartamento</label>
                                        <select
                                            value={searchFilters.apartamento}
                                            onChange={(e) => { setSearchFilters((prev) => ({ ...prev, apartamento: e.target.value })); setPage(0); }}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                                        >
                                            <option value="">Todos</option>
                                            {searchApartments.length > 0 ? (
                                                searchApartments.map((aparto) => (
                                                    <option key={aparto.id_apartamento} value={aparto.id_apartamento}>{aparto.num_apartamento}</option>
                                                ))
                                            ) : (
                                                <option disabled>{searchFilters.torre ? 'Sin apartamentos' : 'Seleccione una torre'}</option>
                                            )}
                                        </select>
                                    </div>
                                    <div>
                                        <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">Nombre</label>
                                        <input
                                            type="text"
                                            value={searchFilters.nombre}
                                            onChange={(e) => { setSearchFilters((prev) => ({ ...prev, nombre: e.target.value })); setPage(0); }}
                                            placeholder="Nombre o apellido"
                                            className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                                        />
                                    </div>
                                </div>
                                <div className="flex justify-end">
                                    <button type="button" onClick={clearSearchFilters}
                                        className="px-4 py-1.5 text-sm text-teal-700 border border-teal-400 rounded-lg hover:bg-teal-50 transition-colors">
                                        Limpiar filtros
                                    </button>
                                </div>
                            </div>
                        )}

                        {/* Filter Tabs */}
                        <div className="bg-white rounded-xl shadow-md overflow-hidden">
                            <div className="flex border-b">
                                <button
                                    onClick={() => { setActiveFilter('todos'); setPage(0); }}
                                    className={`flex-1 px-4 py-3 text-center text-sm font-semibold transition-colors ${
                                        activeFilter === 'todos' ? 'bg-teal-600 text-white' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'
                                    }`}
                                >
                                    <FontAwesomeIcon icon={faBoxOpen} className="mr-1.5" />
                                    Todos ({stats.total})
                                </button>
                                <button
                                    onClick={() => { setActiveFilter('entregados'); setPage(0); }}
                                    className={`flex-1 px-4 py-3 text-center text-sm font-semibold transition-colors ${
                                        activeFilter === 'entregados' ? 'bg-green-600 text-white' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'
                                    }`}
                                >
                                    <FontAwesomeIcon icon={faCircleCheck} className="mr-1.5" />
                                    Entregados ({stats.entregados})
                                </button>
                                <button
                                    onClick={() => { setActiveFilter('pendientes'); setPage(0); }}
                                    className={`flex-1 px-4 py-3 text-center text-sm font-semibold transition-colors ${
                                        activeFilter === 'pendientes' ? 'bg-amber-600 text-white' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'
                                    }`}
                                >
                                    <FontAwesomeIcon icon={faClock} className="mr-1.5" />
                                    Pendientes ({stats.pendientes})
                                </button>
                            </div>
                        </div>

                        {/* Main Table */}
                        <div className="bg-white rounded-xl shadow-md overflow-hidden">
                            <div className="px-5 py-3 border-b border-gray-100 bg-gray-50 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                                <h3 className="text-sm font-semibold text-gray-800">
                                    {selectedTowerCard
                                        ? `Paquetes de ${towerCardsData.find((t) => t.id_torre === selectedTowerCard)?.torre_nombre || 'la torre seleccionada'}`
                                        : 'Listado general de paquetes'}
                                </h3>
                                <p className="text-xs text-gray-500">{filteredPaqueteria.length} resultado(s)</p>
                            </div>
                            <div className="overflow-x-auto">
                                <table className="min-w-full divide-y divide-gray-200">
                                    <thead className="bg-gradient-to-r from-teal-500 to-cyan-600">
                                        <tr>
                                            <th className="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">Torre</th>
                                            <th className="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">Apto.</th>
                                            <th className="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">Nombre</th>
                                            <th className="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">Fecha ingreso</th>
                                            <th className="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">Estado</th>
                                            <th className="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">Info</th>
                                            <th className="px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">Editar</th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200">
                                        {filteredPaqueteria.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((paquete) => (
                                            <tr key={paquete.id_paquete} className={getRowColor(paquete.estado)}>
                                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">{paquete.torre_nombre}</td>
                                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">{paquete.num_apartamento}</td>
                                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">{paquete.nombre} {paquete.apellido}</td>
                                                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">{formatDate(paquete.fecha_recibido)}</td>
                                                <td className="px-4 py-3 whitespace-nowrap text-sm">
                                                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                                                        paquete.estado === 'Entregado' ? 'bg-green-100 text-green-800' : 'bg-amber-100 text-amber-800'
                                                    }`}>
                                                        {paquete.estado}
                                                    </span>
                                                </td>
                                                <td className="px-4 py-3 whitespace-nowrap text-sm">
                                                    <button
                                                        onClick={() => handleInfoPackage(paquete)}
                                                        className="inline-flex items-center px-2.5 py-1 border border-teal-500 text-teal-600 rounded-lg hover:bg-teal-50 transition-colors"
                                                    >
                                                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                                        </svg>
                                                    </button>
                                                </td>
                                                <td className="px-4 py-3 whitespace-nowrap text-sm">
                                                    <button
                                                        onClick={() => handleEditPackage(paquete)}
                                                        disabled={paquete.estado === 'Entregado'}
                                                        className={`inline-flex items-center px-2.5 py-1 rounded-lg transition-colors ${
                                                            paquete.estado === 'Entregado'
                                                                ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                                                                : 'bg-gradient-to-r from-teal-500 to-cyan-600 text-white hover:from-teal-600 hover:to-cyan-700'
                                                        }`}
                                                    >
                                                        <FontAwesomeIcon icon={faPenToSquare} className="w-4 h-4" />
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            {/* Pagination */}
                            <div className="bg-gray-50 px-4 py-3 flex flex-col sm:flex-row items-center justify-between gap-2 border-t border-gray-200">
                                <p className="text-sm text-gray-600">
                                    <span className="font-medium">{page * rowsPerPage + 1}</span>–<span className="font-medium">{Math.min((page + 1) * rowsPerPage, filteredPaqueteria.length)}</span>{' '}de{' '}<span className="font-medium">{filteredPaqueteria.length}</span> resultados
                                </p>
                                <div className="flex items-center gap-3">
                                    <div className="flex items-center gap-1.5">
                                        <label className="text-xs text-gray-600">Filas:</label>
                                        <select
                                            value={rowsPerPage}
                                            onChange={(e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }}
                                            className="px-2 py-1 border border-gray-300 rounded-md text-xs"
                                        >
                                            <option value={5}>5</option>
                                            <option value={10}>10</option>
                                            <option value={25}>25</option>
                                        </select>
                                    </div>
                                    <div className="flex gap-1.5">
                                        <button
                                            onClick={() => setPage(Math.max(0, page - 1))}
                                            disabled={page === 0}
                                            className="px-3 py-1.5 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                                        >
                                            &#8249; Anterior
                                        </button>
                                        <button
                                            onClick={() => setPage(Math.min(Math.ceil(filteredPaqueteria.length / rowsPerPage) - 1, page + 1))}
                                            disabled={page >= Math.ceil(filteredPaqueteria.length / rowsPerPage) - 1}
                                            className="px-3 py-1.5 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                                        >
                                            Siguiente &#8250;
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        

        {/* ADD PACKAGE DIALOG */}
        {openAddDialog && (
            <div className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm overflow-y-auto">
                <div className="flex items-center justify-center min-h-screen p-4">
                    <div className="w-full max-w-3xl bg-white rounded-2xl text-left overflow-hidden shadow-2xl">
                        <form onSubmit={handleAddPackage}>
                            <div className="bg-gradient-to-r from-teal-500 to-cyan-600 px-6 py-5 flex items-center justify-between">
                                <h3 className="text-xl font-semibold text-white">Agregar Paquete</h3>
                                <button type="button" onClick={() => setOpenAddDialog(false)} className="text-white/90 hover:text-white">
                                    <FontAwesomeIcon icon={faXmark} className="w-5 h-5" />
                                </button>
                            </div>
                            <div className="bg-white px-6 py-6 max-h-[calc(100vh-220px)] overflow-y-auto space-y-6">

                                {/* Sección 1: Ubicación */}
                                <div>
                                    <div className="flex items-center gap-2 mb-4">
                                        <div className="p-2 bg-teal-100 rounded-lg">
                                            <FontAwesomeIcon icon={faBuilding} className="w-4 h-4 text-teal-600" />
                                        </div>
                                        <div>
                                            <h4 className="text-sm font-bold text-gray-800">Ubicación</h4>
                                            <p className="text-xs text-gray-500">Torre y apartamento del destinatario</p>
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">Torre <span className="text-red-500">*</span></label>
                                            <select
                                                value={newPackage.torre}
                                                onChange={handleTorreChange}
                                                className="w-full px-3 py-2.5 border border-gray-300 rounded-xl text-sm bg-gray-50 focus:bg-white focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition-colors"
                                                required
                                            >
                                                <option value="">Seleccionar torre...</option>
                                                {torres.map((torre) => (
                                                    <option key={torre.id_torre} value={torre.id_torre}>{torre.nombre}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div>
                                            <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">Apartamento <span className="text-red-500">*</span></label>
                                            <select
                                                value={newPackage.id_apartamento}
                                                onChange={handleApartamentoChange}
                                                className="w-full px-3 py-2.5 border border-gray-300 rounded-xl text-sm bg-gray-50 focus:bg-white focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition-colors"
                                                required
                                            >
                                                <option value="">Seleccionar apartamento...</option>
                                                {apartamentos.length > 0 ? (
                                                    apartamentos.map((apartamento) => (
                                                        <option key={apartamento.id_apartamento} value={apartamento.id_apartamento}>{apartamento.num_apartamento}</option>
                                                    ))
                                                ) : (
                                                    <option disabled>Seleccione primero una torre</option>
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className="border-t border-gray-100" />

                                {/* Sección 2: Destinatario */}
                                <div>
                                    <div className="flex items-center gap-2 mb-4">
                                        <div className="p-2 bg-blue-100 rounded-lg">
                                            <FontAwesomeIcon icon={faUser} className="w-4 h-4 text-blue-600" />
                                        </div>
                                        <div>
                                            <h4 className="text-sm font-bold text-gray-800">Destinatario</h4>
                                            <p className="text-xs text-gray-500">Datos del residente que recibe el paquete</p>
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                        <div className="md:col-span-3">
                                            <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">Residente <span className="text-red-500">*</span></label>
                                            <select
                                                value={newPackage.id_usuario}
                                                onChange={handleUsuarioChange}
                                                className="w-full px-3 py-2.5 border border-gray-300 rounded-xl text-sm bg-gray-50 focus:bg-white focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition-colors"
                                                required
                                            >
                                                <option value="">Seleccionar residente...</option>
                                                {usuarios.length > 0 ? (
                                                    usuarios.map((usuario) => (
                                                        <option key={usuario.id_usuario} value={usuario.id_usuario}>{usuario.nombre} {usuario.apellido}</option>
                                                    ))
                                                ) : (
                                                    <option disabled>Seleccione primero un apartamento</option>
                                                )}
                                            </select>
                                        </div>
                                        <div>
                                            <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">
                                                <FontAwesomeIcon icon={faPhone} className="mr-1 text-gray-400" />Teléfono <span className="text-red-500">*</span>
                                            </label>
                                            <input
                                                type="tel"
                                                value={newPackage.telefono}
                                                onChange={(e) => setNewPackage({ ...newPackage, telefono: e.target.value })}
                                                placeholder="Ej: 3001234567"
                                                className="w-full px-3 py-2.5 border border-gray-300 rounded-xl text-sm bg-gray-50 focus:bg-white focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition-colors"
                                                required
                                            />
                                        </div>
                                        <div className="md:col-span-2">
                                            <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">
                                                <FontAwesomeIcon icon={faEnvelope} className="mr-1 text-gray-400" />Correo electrónico <span className="text-red-500">*</span>
                                            </label>
                                            <input
                                                type="email"
                                                value={newPackage.email}
                                                onChange={(e) => setNewPackage({ ...newPackage, email: e.target.value })}
                                                placeholder="correo@ejemplo.com"
                                                className="w-full px-3 py-2.5 border border-gray-300 rounded-xl text-sm bg-gray-50 focus:bg-white focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition-colors"
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="border-t border-gray-100" />

                                {/* Sección 3: Detalles del paquete */}
                                <div>
                                    <div className="flex items-center gap-2 mb-4">
                                        <div className="p-2 bg-purple-100 rounded-lg">
                                            <FontAwesomeIcon icon={faBox} className="w-4 h-4 text-purple-600" />
                                        </div>
                                        <div>
                                            <h4 className="text-sm font-bold text-gray-800">Detalles del paquete</h4>
                                            <p className="text-xs text-gray-500">Información sobre el envío recibido</p>
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">Tipo de paquete <span className="text-red-500">*</span></label>
                                            <select
                                                value={newPackage.tipo_paquete}
                                                onChange={(e) => setNewPackage({ ...newPackage, tipo_paquete: e.target.value })}
                                                className="w-full px-3 py-2.5 border border-gray-300 rounded-xl text-sm bg-gray-50 focus:bg-white focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition-colors"
                                                required
                                            >
                                                <option value="">Seleccionar tipo...</option>
                                                {packageTypes.map((type) => (
                                                    <option key={type.id_tipo_paquete} value={type.id_tipo_paquete}>{type.tipo_paquete}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div>
                                            <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">Cantidad <span className="text-red-500">*</span></label>
                                            <div className="flex items-center gap-2">
                                                <button type="button" onClick={() => { if (newPackage.cantidad > 1) setNewPackage({ ...newPackage, cantidad: newPackage.cantidad - 1 }); }}
                                                    className="w-9 h-9 rounded-xl border border-gray-300 bg-gray-50 hover:bg-gray-100 text-gray-700 font-bold text-lg flex items-center justify-center transition-colors">−</button>
                                                <input
                                                    type="number"
                                                    value={newPackage.cantidad}
                                                    onChange={(e) => { const v = parseInt(e.target.value, 10); if (v >= 1 && v <= 20) setNewPackage({ ...newPackage, cantidad: v }); }}
                                                    min="1" max="20"
                                                    className="flex-1 px-3 py-2.5 border border-gray-300 rounded-xl text-sm text-center bg-gray-50 focus:bg-white focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition-colors"
                                                    required
                                                />
                                                <button type="button" onClick={() => { if (newPackage.cantidad < 20) setNewPackage({ ...newPackage, cantidad: newPackage.cantidad + 1 }); }}
                                                    className="w-9 h-9 rounded-xl border border-gray-300 bg-gray-50 hover:bg-gray-100 text-gray-700 font-bold text-lg flex items-center justify-center transition-colors">+</button>
                                            </div>
                                        </div>
                                        <div>
                                            <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">
                                                <FontAwesomeIcon icon={faTruck} className="mr-1 text-gray-400" />Remitente <span className="text-red-500">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                value={newPackage.remitente}
                                                onChange={(e) => setNewPackage({ ...newPackage, remitente: e.target.value })}
                                                placeholder="Ej: Amazon, Coordinadora..."
                                                className="w-full px-3 py-2.5 border border-gray-300 rounded-xl text-sm bg-gray-50 focus:bg-white focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition-colors"
                                                required
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">Observación <span className="text-red-500">*</span></label>
                                            <input
                                                type="text"
                                                value={newPackage.observacion}
                                                onChange={(e) => setNewPackage({ ...newPackage, observacion: e.target.value })}
                                                placeholder="Descripción breve del paquete"
                                                className="w-full px-3 py-2.5 border border-gray-300 rounded-xl text-sm bg-gray-50 focus:bg-white focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition-colors"
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>

                            </div>
                            {aptMora && (
                                <div className="flex items-start gap-3 bg-red-50 border-t border-red-300 px-6 py-4">
                                    <FontAwesomeIcon icon={faExclamationTriangle} className="text-red-600 mt-0.5 flex-shrink-0 text-lg" />
                                    <div>
                                        <p className="text-sm font-bold text-red-800">No se puede recibir el paquete</p>
                                        <p className="text-sm text-red-700 mt-0.5">{moraMensaje}</p>
                                    </div>
                                </div>
                            )}
                            <div className="bg-gray-50 px-6 py-4 flex gap-3 justify-end border-t border-gray-100">
                                <button
                                    type="button"
                                    onClick={() => setOpenAddDialog(false)}
                                    className="px-5 py-2.5 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors"
                                >
                                    Cancelar
                                </button>
                                <button
                                    type="submit"
                                    disabled={aptMora}
                                    className={`px-5 py-2.5 rounded-lg transition-all ${
                                        aptMora
                                            ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                            : 'bg-gradient-to-r from-teal-500 to-cyan-600 text-white hover:from-teal-600 hover:to-cyan-700'
                                    }`}
                                >
                                    Agregar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )}

        {/* PACKAGE INFO DIALOG */}
        {openDialog && (
            <div className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm overflow-y-auto">
                <div className="flex items-center justify-center min-h-screen p-4">
                    <div className="w-full max-w-4xl bg-white rounded-2xl text-left overflow-hidden shadow-2xl">
                        <div className="bg-gradient-to-r from-teal-500 to-cyan-600 px-6 py-5 flex items-start justify-between gap-4">
                            <div className="flex items-center gap-3">
                                <div className="p-2 bg-white/20 rounded-lg">
                                    <FontAwesomeIcon icon={faBoxOpen} className="w-6 h-6 text-white" />
                                </div>
                                <div>
                                    <h3 className="text-xl font-semibold text-white">Información del Paquete</h3>
                                    {packageInfo && (
                                        <p className="text-sm text-white/90 mt-0.5">
                                            Estado: <span className="font-semibold">{packageInfo.estado}</span>
                                            {packageInfo.estado === 'Entregado' && packageInfo.fecha_entrega && (
                                                <span> • {formatDate(packageInfo.fecha_entrega)}</span>
                                            )}
                                        </p>
                                    )}
                                </div>
                            </div>
                            <button type="button" onClick={handleClose} className="text-white/90 hover:text-white transition-colors">
                                <FontAwesomeIcon icon={faXmark} className="w-5 h-5" />
                            </button>
                        </div>
                        <div className="bg-white px-6 py-6 max-h-[calc(100vh-220px)] overflow-y-auto space-y-5">
                            {packageInfo ? (
                                <>
                                    {/* Sección 1: Detalles del paquete */}
                                    <div>
                                        <div className="flex items-center gap-2 mb-3">
                                            <div className="p-2 bg-purple-100 rounded-lg">
                                                <FontAwesomeIcon icon={faBox} className="w-4 h-4 text-purple-600" />
                                            </div>
                                            <h4 className="text-sm font-bold text-gray-800">Detalles del Paquete</h4>
                                        </div>
                                        <div className="bg-gray-50 rounded-xl p-4 grid grid-cols-2 gap-x-6 gap-y-3">
                                            <div>
                                                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Tipo de paquete</p>
                                                <p className="text-sm text-gray-900 font-medium">{packageInfo.tipo_paquete}</p>
                                            </div>
                                            <div>
                                                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Cantidad</p>
                                                <p className="text-sm text-gray-900 font-medium">{packageInfo.cantidad} unidad(es)</p>
                                            </div>
                                            <div>
                                                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">
                                                    <FontAwesomeIcon icon={faTruck} className="mr-1 text-gray-400" />Remitente
                                                </p>
                                                <p className="text-sm text-gray-900 font-medium">{packageInfo.remitente}</p>
                                            </div>
                                            <div>
                                                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Fecha de recibido</p>
                                                <p className="text-sm text-gray-900 font-medium">{formatDate(packageInfo.fecha_recibido)}</p>
                                            </div>
                                            <div className="col-span-2">
                                                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Observaciones</p>
                                                <p className="text-sm text-gray-900">{packageInfo.observacion}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="border-t border-gray-100" />

                                    {/* Sección 2: Destinatario */}
                                    <div>
                                        <div className="flex items-center gap-2 mb-3">
                                            <div className="p-2 bg-blue-100 rounded-lg">
                                                <FontAwesomeIcon icon={faUser} className="w-4 h-4 text-blue-600" />
                                            </div>
                                            <h4 className="text-sm font-bold text-gray-800">Destinatario</h4>
                                        </div>
                                        <div className="bg-gray-50 rounded-xl p-4 grid grid-cols-2 gap-x-6 gap-y-3">
                                            <div>
                                                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Nombre completo</p>
                                                <p className="text-sm text-gray-900 font-medium">{packageInfo.nombre} {packageInfo.apellido}</p>
                                            </div>
                                            <div>
                                                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">
                                                    <FontAwesomeIcon icon={faPhone} className="mr-1 text-gray-400" />Teléfono
                                                </p>
                                                <div className="flex items-center gap-2">
                                                    <p className="text-sm text-gray-900 font-medium">{packageInfo.telefono}</p>
                                                    {packageInfo.estado === 'Pendiente' && (
                                                        <div className="flex gap-1.5">
                                                            <a href={`https://wa.me/+57${packageInfo.telefono}`} target="_blank" rel="noopener noreferrer"
                                                                className="p-1 text-green-600 hover:bg-green-50 rounded transition-colors">
                                                                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                                                                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                                                                </svg>
                                                            </a>
                                                            <a href={`tel:+57${packageInfo.telefono}`}
                                                                className="p-1 text-teal-600 hover:bg-teal-50 rounded transition-colors">
                                                                <FontAwesomeIcon icon={faPhone} className="w-4 h-4" />
                                                            </a>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-span-2">
                                                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">
                                                    <FontAwesomeIcon icon={faEnvelope} className="mr-1 text-gray-400" />Correo electrónico
                                                </p>
                                                <p className="text-sm text-gray-900">{packageInfo.email}</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="border-t border-gray-100" />

                                    {/* Sección 3: Ubicación */}
                                    <div>
                                        <div className="flex items-center gap-2 mb-3">
                                            <div className="p-2 bg-teal-100 rounded-lg">
                                                <FontAwesomeIcon icon={faBuilding} className="w-4 h-4 text-teal-600" />
                                            </div>
                                            <h4 className="text-sm font-bold text-gray-800">Ubicación</h4>
                                        </div>
                                        <div className="bg-gray-50 rounded-xl p-4 grid grid-cols-3 gap-x-6 gap-y-3">
                                            <div>
                                                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Torre</p>
                                                <p className="text-sm text-gray-900 font-medium">{packageInfo.torre_nombre}</p>
                                            </div>
                                            <div>
                                                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Apartamento</p>
                                                <p className="text-sm text-gray-900 font-medium">{packageInfo.num_apartamento}</p>
                                            </div>
                                            <div>
                                                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Piso</p>
                                                <p className="text-sm text-gray-900 font-medium">{packageInfo.piso}</p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Firma de entrega */}
                                    {packageInfo.estado !== 'Pendiente' && (
                                        <>
                                            <div className="border-t border-gray-100" />
                                            <div>
                                                <div className="flex items-center gap-2 mb-3">
                                                    <div className="p-2 bg-green-100 rounded-lg">
                                                        <FontAwesomeIcon icon={faCircleCheck} className="w-4 h-4 text-green-600" />
                                                    </div>
                                                    <h4 className="text-sm font-bold text-gray-800">Firma de Recibido</h4>
                                                </div>
                                                <div className="bg-gray-50 rounded-xl p-4 flex justify-center items-center min-h-[200px]">
                                                    {packageInfo.firma_entrega ? (
                                                        <img src={`${BASE_URL}/${packageInfo.firma_entrega}`} alt="Firma de entrega"
                                                            className="max-w-full max-h-64 object-contain border-2 border-gray-200 rounded-lg bg-white p-2" />
                                                    ) : (
                                                        <p className="text-sm text-gray-500">No hay firma de entrega disponible</p>
                                                    )}
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </>
                            ) : (
                                <div className="text-center py-8 text-gray-500">Cargando...</div>
                            )}
                        </div>
                        <div className="bg-gray-50 px-6 py-4 flex justify-end border-t border-gray-100">
                            <button
                                onClick={() => {
                                    if (packageInfo && packageInfo.estado === 'Entregado') {
                                        handleClose();
                                    } else {
                                        if (isPackageRegistered) {
                                            handleClose();
                                        } else {
                                            if (packageInfo && packageInfo.id_paquete) {
                                                handleRegisterPackage(packageInfo);
                                            } else {
                                                console.error("Paquete no seleccionado o id_paquete no definido.");
                                            }
                                        }
                                    }
                                }}
                                disabled={isPackageRegistered && packageInfo && packageInfo.estado !== 'Entregado'}
                                className={`px-6 py-2 rounded-lg font-semibold transition-all ${
                                    isPackageRegistered && packageInfo && packageInfo.estado !== 'Entregado'
                                        ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                                        : 'bg-gradient-to-r from-green-500 to-green-600 text-white hover:from-green-600 hover:to-green-700'
                                }`}
                            >
                                {packageInfo && packageInfo.estado === 'Entregado' ? 'Cerrar' : (isPackageRegistered ? 'Paquete ya registrado' : 'Registrar paquete')}
                            </button>
                            <SignatureDialog
                                open={openSignatureDialog}
                                onClose={() => setOpenSignatureDialog(false)}
                                onSave={handleSaveSignature}
                                id_paquete={selectedPackage?.id_paquete}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )}

        {/* EDIT PACKAGE DIALOG */}
        {openEditDialog && (
            <div className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm overflow-y-auto">
                <div className="flex items-center justify-center min-h-screen p-4">
                    <div className="w-full max-w-4xl bg-white rounded-2xl text-left overflow-hidden shadow-2xl">
                        <form onSubmit={updatePackage}>
                            <div className="bg-gradient-to-r from-teal-500 to-cyan-600 px-6 py-5 flex items-center justify-between">
                                <div className="flex items-center gap-3">
                                    <div className="p-2 bg-white/20 rounded-lg">
                                        <FontAwesomeIcon icon={faPenToSquare} className="w-5 h-5 text-white" />
                                    </div>
                                    <h3 className="text-xl font-semibold text-white">Editar Paquete</h3>
                                </div>
                                <button type="button" onClick={() => setOpenEditDialog(false)} className="text-white/90 hover:text-white transition-colors">
                                    <FontAwesomeIcon icon={faXmark} className="w-5 h-5" />
                                </button>
                            </div>
                            <div className="bg-white px-6 py-6 max-h-[calc(100vh-220px)] overflow-y-auto space-y-6">
                                <input type="hidden" id="id_paquete" value={editPackage.id_paquete || ''} />

                                {/* Sección 1: Información básica (solo lectura) */}
                                <div>
                                    <div className="flex items-center gap-2 mb-4">
                                        <div className="p-2 bg-gray-100 rounded-lg">
                                            <FontAwesomeIcon icon={faUser} className="w-4 h-4 text-gray-600" />
                                        </div>
                                        <div>
                                            <h4 className="text-sm font-bold text-gray-800">Información del Residente</h4>
                                            <p className="text-xs text-gray-500">Datos de solo lectura</p>
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                        <div>
                                            <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">Nombre</label>
                                            <input type="text" value={editPackage.nombre || ''} disabled
                                                className="w-full px-3 py-2.5 border border-gray-200 rounded-xl bg-gray-50 text-gray-500 text-sm" />
                                        </div>
                                        <div>
                                            <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">Apellido</label>
                                            <input type="text" value={editPackage.apellido || ''} disabled
                                                className="w-full px-3 py-2.5 border border-gray-200 rounded-xl bg-gray-50 text-gray-500 text-sm" />
                                        </div>
                                        <div>
                                            <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">Fecha de recibido</label>
                                            <input type="datetime-local" value={editPackage.fecha_recibido ? new Date(editPackage.fecha_recibido).toISOString().slice(0, 16) : ''} disabled
                                                className="w-full px-3 py-2.5 border border-gray-200 rounded-xl bg-gray-50 text-gray-500 text-sm" />
                                        </div>
                                    </div>
                                </div>

                                <div className="border-t border-gray-100" />

                                {/* Sección 2: Ubicación (solo lectura) */}
                                <div>
                                    <div className="flex items-center gap-2 mb-4">
                                        <div className="p-2 bg-teal-100 rounded-lg">
                                            <FontAwesomeIcon icon={faBuilding} className="w-4 h-4 text-teal-600" />
                                        </div>
                                        <div>
                                            <h4 className="text-sm font-bold text-gray-800">Ubicación</h4>
                                            <p className="text-xs text-gray-500">Torre y apartamento (no editables)</p>
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">Torre</label>
                                            <input type="text" value={editPackage.torre_nombre || ''} disabled
                                                className="w-full px-3 py-2.5 border border-gray-200 rounded-xl bg-gray-50 text-gray-500 text-sm" />
                                        </div>
                                        <div>
                                            <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">Apartamento</label>
                                            <input type="text" value={editPackage.num_apartamento || ''} disabled
                                                className="w-full px-3 py-2.5 border border-gray-200 rounded-xl bg-gray-50 text-gray-500 text-sm" />
                                        </div>
                                    </div>
                                </div>

                                <div className="border-t border-gray-100" />

                                {/* Sección 3: Datos editables */}
                                <div>
                                    <div className="flex items-center gap-2 mb-4">
                                        <div className="p-2 bg-blue-100 rounded-lg">
                                            <FontAwesomeIcon icon={faPhone} className="w-4 h-4 text-blue-600" />
                                        </div>
                                        <div>
                                            <h4 className="text-sm font-bold text-gray-800">Datos de Contacto</h4>
                                            <p className="text-xs text-gray-500">Información editable</p>
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">
                                                <FontAwesomeIcon icon={faPhone} className="mr-1 text-gray-400" />Teléfono <span className="text-red-500">*</span>
                                            </label>
                                            <input type="number" value={editPackage.telefono || ''}
                                                onChange={(e) => setEditPackage({ ...editPackage, telefono: e.target.value })}
                                                placeholder="Ej: 3001234567"
                                                className="w-full px-3 py-2.5 border border-gray-300 rounded-xl text-sm bg-white focus:bg-white focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition-colors"
                                                required />
                                        </div>
                                        <div>
                                            <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">
                                                <FontAwesomeIcon icon={faEnvelope} className="mr-1 text-gray-400" />Correo electrónico <span className="text-red-500">*</span>
                                            </label>
                                            <input type="email" value={editPackage.email || ''}
                                                onChange={(e) => setEditPackage({ ...editPackage, email: e.target.value })}
                                                placeholder="correo@ejemplo.com"
                                                className="w-full px-3 py-2.5 border border-gray-300 rounded-xl text-sm bg-white focus:bg-white focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition-colors"
                                                required />
                                        </div>
                                    </div>
                                </div>

                                <div className="border-t border-gray-100" />

                                {/* Sección 4: Detalles del paquete editables */}
                                <div>
                                    <div className="flex items-center gap-2 mb-4">
                                        <div className="p-2 bg-purple-100 rounded-lg">
                                            <FontAwesomeIcon icon={faBox} className="w-4 h-4 text-purple-600" />
                                        </div>
                                        <div>
                                            <h4 className="text-sm font-bold text-gray-800">Detalles del Paquete</h4>
                                            <p className="text-xs text-gray-500">Información editable del envío</p>
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">Tipo de paquete <span className="text-red-500">*</span></label>
                                            <select value={packageTypesEdit.some(type => type.id_tipo_paquete === editPackage.tipo_paquete) ? editPackage.tipo_paquete : ''}
                                                onChange={(e) => setEditPackage({ ...editPackage, tipo_paquete: e.target.value })}
                                                className="w-full px-3 py-2.5 border border-gray-300 rounded-xl text-sm bg-white focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition-colors"
                                                required>
                                                <option value="">Seleccionar tipo...</option>
                                                {packageTypesEdit.map((type) => (
                                                    <option key={type.id_tipo_paquete} value={type.id_tipo_paquete}>{type.tipo_paquete}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div>
                                            <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">Cantidad <span className="text-red-500">*</span></label>
                                            <div className="flex items-center gap-2">
                                                <button type="button" onClick={() => { if (editPackage.cantidad > 1) setEditPackage({ ...editPackage, cantidad: editPackage.cantidad - 1 }); }}
                                                    className="w-9 h-9 rounded-xl border border-gray-300 bg-gray-50 hover:bg-gray-100 text-gray-700 font-bold text-lg flex items-center justify-center transition-colors">−</button>
                                                <input type="number" value={editPackage.cantidad || ''}
                                                    onChange={(e) => { const v = parseInt(e.target.value, 10); if (v >= 1 && v <= 20) setEditPackage({ ...editPackage, cantidad: v }); }}
                                                    min="1" max="20"
                                                    className="flex-1 px-3 py-2.5 border border-gray-300 rounded-xl text-sm text-center bg-white focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition-colors"
                                                    required />
                                                <button type="button" onClick={() => { if (editPackage.cantidad < 20) setEditPackage({ ...editPackage, cantidad: editPackage.cantidad + 1 }); }}
                                                    className="w-9 h-9 rounded-xl border border-gray-300 bg-gray-50 hover:bg-gray-100 text-gray-700 font-bold text-lg flex items-center justify-center transition-colors">+</button>
                                            </div>
                                        </div>
                                        <div>
                                            <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">
                                                <FontAwesomeIcon icon={faTruck} className="mr-1 text-gray-400" />Remitente <span className="text-red-500">*</span>
                                            </label>
                                            <input type="text" value={editPackage.remitente || ''}
                                                onChange={(e) => setEditPackage({ ...editPackage, remitente: e.target.value })}
                                                placeholder="Ej: Amazon, Coordinadora..."
                                                className="w-full px-3 py-2.5 border border-gray-300 rounded-xl text-sm bg-white focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition-colors"
                                                required />
                                        </div>
                                        <div>
                                            <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">Estado <span className="text-red-500">*</span></label>
                                            <select value={editPackage.estado || ''}
                                                onChange={(e) => setEditPackage({ ...editPackage, estado: e.target.value })}
                                                className="w-full px-3 py-2.5 border border-gray-300 rounded-xl text-sm bg-white focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition-colors"
                                                required>
                                                <option value="">Seleccionar estado...</option>
                                                <option value="Pendiente">Pendiente</option>
                                                <option value="Entregado">Entregado</option>
                                            </select>
                                        </div>
                                        <div className="md:col-span-2">
                                            <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1.5">Observación <span className="text-red-500">*</span></label>
                                            <input type="text" value={editPackage.observacion || ''}
                                                onChange={(e) => setEditPackage({ ...editPackage, observacion: e.target.value })}
                                                placeholder="Descripción breve del paquete"
                                                className="w-full px-3 py-2.5 border border-gray-300 rounded-xl text-sm bg-white focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition-colors"
                                                required />
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="bg-gray-50 px-6 py-4 flex gap-3 justify-end border-t border-gray-100">
                                <button
                                    type="button"
                                    onClick={() => setOpenEditDialog(false)}
                                    className="px-5 py-2.5 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors"
                                >
                                    Cancelar
                                </button>
                                <button
                                    type="submit"
                                    className="px-5 py-2.5 bg-gradient-to-r from-teal-500 to-cyan-600 text-white rounded-lg hover:from-teal-600 hover:to-cyan-700 transition-all"
                                >
                                    Editar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )}
    </>
  );
}

export default PackageControl;
